import React from 'react';
import TableAction from './TableAction';
import SaveAltIcon from '@material-ui/icons/SaveAlt';

interface TableDownloadActionProps<T, K extends keyof T> {
  data: T[],
  idKey?: K
  selectedIds?: T[K][],
  fileName?: string,
  headers?: (keyof T)[]
}

const TableDownloadAction = <T,K extends keyof T>(props: TableDownloadActionProps<T,K>) => {
  const {data, idKey, selectedIds, fileName = 'data.csv', headers = Object.keys(data[0] || {})} = props;

  const downloadAll = (!idKey && !selectedIds) || selectedIds.length === 0;

  const onDownload = React.useCallback(() => {
    let finalData = data;
    if(!downloadAll) {
      const selectedSet = new Set<T[K]>(selectedIds);
      finalData = data.filter((item) => selectedSet.has(item[idKey]));
    }

    const csvString = finalData.reduce((acc, curr) => 
      acc + headers.map(h => curr[h] != null && curr[h].toString() || '').join(',') + '\n'
    , headers.join(',') + '\n');

    const a = document.createElement('a');
    a.href = URL.createObjectURL(new Blob([csvString], {
      type: 'text/csv'
    }))
    a.download = fileName;
    a.click();
    a.remove();

  }, [downloadAll, data, selectedIds, idKey]);

  return <TableAction
    onClick={onDownload}
    title={downloadAll ? 'Export Data to CSV':'Export Selected Data to CSV'}
  >
    <SaveAltIcon/>
  </TableAction>
}

export default TableDownloadAction;